import Header from "./components/Header";
import Footer from "./components/Footer";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <Header />

      {/* Middle part changes here */}
      <main className="pt-16 min-h-screen">
        <Outlet />
      </main>

      <Footer />
    </>
  );
};

export default Layout;